import ColorSchemeCompareSlider, {
    SliderInstance,
} from '../components/ColorSchemeCompareSlider';
import { initColorSchemePhotoSlideShows } from '../components/ColorSchemeOverviewPhotoSlideshow';
import QuickViewModal from '../components/QuickViewModal';

document.addEventListener('DOMContentLoaded', () => {
    //quick view init
    const quickviewModal = QuickViewModal('js-quickview-modal');

    initColorSchemePhotoSlideShows();

    const compareSlideshows = document.querySelectorAll<HTMLElement>(
        '.js-compare-slideshows',
    );

    const sliderInstances: SliderInstance[] = []; // Array with the type

    const goToSlideOnAllSliders = (slideIndex: number) => {
        sliderInstances.forEach(sliderInstance => {
            sliderInstance.goToSlide(slideIndex);
        });
    };

    compareSlideshows.forEach(cs => {
        const slideshow = ColorSchemeCompareSlider(cs.id);
        if (slideshow) {
            slideshow.init();
            sliderInstances.push(slideshow);
        }
    });

    const compareNavBtns =
        document.querySelectorAll<HTMLButtonElement>('.js-btn-cs-compare');

    compareNavBtns.forEach(btn => {
        btn.addEventListener('click', (event: Event) => {
            event.preventDefault();
            const filterBtn = event.target as HTMLButtonElement;

            if (filterBtn.classList.contains('active')) {
                return; // Exit if the clicked button is already active
            }

            const indexValue: number = parseInt(filterBtn.dataset.index || '0');

            compareNavBtns.forEach(button => {
                button.classList.remove('active'); // Remove the active class from all buttons
            });

            filterBtn.classList.add('active');

            goToSlideOnAllSliders(indexValue);
        });
    });
});
